import {Authority} from "root/Common/Constants/PassportAuthorityTypes.mjs";

/**
 * Enum for different types of panel
 *
 * <pre>
 *     MODAL_SEND_ASSESSMENT = Text in ModalSubmitSENDAssessment
 * </pre>
 *
 * @readonly
 *
 * @enum {VariantString}
 */
export const VariantString =
    {
        MODAL_SEND_ASSESSMENT : 1,
        MODAL_SUBMIT_SEND_ASSESSMENT : 2,
        SEND_CHECKER_TAB_TITLE : 3,
        ACTIONS_TAB_TITLE : 4,
        DEFAULT_CHILD_TAB : 5,
        APPLICATION_NAME : 6,
        INCLUSION_FUNDING_TITLE : 7,
        EHAP_LABEL : 8,
        LAC_LABEL : 9,
        SEND_BUTTON_TEXT : 10,
        SEND_NARRATIVE : 11,
        SEND_PROVENANCE: 12,
        SEND_DASHBOARD_TITLE: 13,
        ESTABLISHMENT_LABEL: 14,
        ALL_ABOUT_ME_TITLE: 15,
    }

const variants = {
    [Authority.NCC] :
        {
            [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new SEND assessment of the child',
            [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the SEND assessment for this child',
            [VariantString.SEND_CHECKER_TAB_TITLE] : 'SEND Checker',
            [VariantString.ACTIONS_TAB_TITLE] : 'Actions',
            [VariantString.DEFAULT_CHILD_TAB] : 'progress',
            [VariantString.APPLICATION_NAME] : 'Northumberland School Readiness Passport',
            [VariantString.INCLUSION_FUNDING_TITLE] : 'EYSTAR Funding?',
            [VariantString.EHAP_LABEL] : 'EHA',
            [VariantString.LAC_LABEL] : 'CfC',
            [VariantString.SEND_BUTTON_TEXT] : 'Create a new SEND Assessment',
            [VariantString.SEND_NARRATIVE] : 'This child has not yet had their fist SEND assessment, so you can start one now by clicking the button below.',
            [VariantString.SEND_PROVENANCE] : 'The SEND Support Checker  was derived from the Early Years Developmental Journal, DFE 2012.',
            [VariantString.SEND_DASHBOARD_TITLE] : 'SEND Progress',
            [VariantString.ESTABLISHMENT_LABEL] : 'Establishment Number',
            [VariantString.ALL_ABOUT_ME_TITLE] : 'All About Me',
        },
        [Authority.GHD] :
            {
                    [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new SEND assessment of the child',
                    [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the SEND assessment for this child',
                    [VariantString.SEND_CHECKER_TAB_TITLE] : 'SEND Checker',
                    [VariantString.ACTIONS_TAB_TITLE] : 'Actions',
                    [VariantString.DEFAULT_CHILD_TAB] : 'progress',
                    [VariantString.APPLICATION_NAME] : 'Northumberland School Readiness Passport',
                    [VariantString.INCLUSION_FUNDING_TITLE] : 'EYSTAR Funding?',
                    [VariantString.EHAP_LABEL] : 'EHA',
                    [VariantString.LAC_LABEL] : 'LAC',
                    [VariantString.SEND_BUTTON_TEXT] : 'Create a new SEND Assessment',
                    [VariantString.SEND_NARRATIVE] : 'This child has not yet had their fist SEND assessment, so you can start one now by clicking the button below.',
                    [VariantString.SEND_PROVENANCE] : 'The SEND Support Checker  was derived from the Early Years Developmental Journal, DFE 2012.',
                    [VariantString.SEND_DASHBOARD_TITLE] : 'SEND Progress',
                    [VariantString.ESTABLISHMENT_LABEL] : 'Establishment Number',
                    [VariantString.ALL_ABOUT_ME_TITLE] : 'All About Me',
            },
    [Authority.DEMO] :
        {
            [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new SEND assessment of the child',
            [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the SEND assessment for this child',
            [VariantString.SEND_CHECKER_TAB_TITLE] : 'SEND Checker',
            [VariantString.ACTIONS_TAB_TITLE] : 'Actions',
            [VariantString.DEFAULT_CHILD_TAB] : 'progress',
            [VariantString.APPLICATION_NAME] : 'Northumberland School Readiness Passport',
            [VariantString.INCLUSION_FUNDING_TITLE] : 'EYSTAR Funding?',
            [VariantString.EHAP_LABEL] : 'EHA',
            [VariantString.LAC_LABEL] : 'LAC',
            [VariantString.SEND_BUTTON_TEXT] : 'Create a new SEND Assessment',
            [VariantString.SEND_NARRATIVE] : 'This child has not yet had their fist SEND assessment, so you can start one now by clicking the button below.',
            [VariantString.SEND_PROVENANCE] : 'The SEND Support Checker  was derived from the Early Years Developmental Journal, DFE 2012.',
            [VariantString.SEND_DASHBOARD_TITLE] : 'SEND Progress',
            [VariantString.ESTABLISHMENT_LABEL] : 'Establishment Number',
            [VariantString.ALL_ABOUT_ME_TITLE] : 'All About Me',
        },
    [Authority.STC] :
        {
            [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new SEND assessment of the child',
            [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the SEND assessment for this child',
            [VariantString.SEND_CHECKER_TAB_TITLE] : 'SEND Checker',
            [VariantString.ACTIONS_TAB_TITLE] : 'Actions',
            [VariantString.DEFAULT_CHILD_TAB] : 'progress',
            [VariantString.APPLICATION_NAME] : 'Northumberland School Readiness Passport',
            [VariantString.INCLUSION_FUNDING_TITLE] : 'EYSTAR Funding?',
            [VariantString.EHAP_LABEL] : 'EHA',
            [VariantString.LAC_LABEL] : 'LAC',
            [VariantString.SEND_BUTTON_TEXT] : 'Create a new SEND Assessment',
            [VariantString.SEND_NARRATIVE] : 'This child has not yet had their fist SEND assessment, so you can start one now by clicking the button below.',
            [VariantString.SEND_PROVENANCE] : 'The SEND Support Checker  was derived from the Early Years Developmental Journal, DFE 2012.',
            [VariantString.SEND_DASHBOARD_TITLE] : 'SEND Progress',
            [VariantString.ESTABLISHMENT_LABEL] : 'Establishment Number',
            [VariantString.ALL_ABOUT_ME_TITLE] : 'All About Me',
        },
    [Authority.SUN] :
        {
            [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new SEND assessment of the child',
            [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the SEND assessment for this child',
            [VariantString.SEND_CHECKER_TAB_TITLE] : 'SEND Checker',
            [VariantString.ACTIONS_TAB_TITLE] : 'Actions',
            [VariantString.DEFAULT_CHILD_TAB] : 'progress',
            [VariantString.APPLICATION_NAME] : 'Northumberland School Readiness Passport',
            [VariantString.INCLUSION_FUNDING_TITLE] : 'EYSTAR Funding?',
            [VariantString.EHAP_LABEL] : 'EHA',
            [VariantString.LAC_LABEL] : 'LAC',
            [VariantString.SEND_BUTTON_TEXT] : 'Create a new SEND Assessment',
            [VariantString.SEND_NARRATIVE] : 'This child has not yet had their fist SEND assessment, so you can start one now by clicking the button below.',
            [VariantString.SEND_PROVENANCE] : 'The SEND Support Checker  was derived from the Early Years Developmental Journal, DFE 2012.',
            [VariantString.SEND_DASHBOARD_TITLE] : 'SEND Progress',
            [VariantString.ESTABLISHMENT_LABEL] : 'URN',
            [VariantString.ALL_ABOUT_ME_TITLE] : 'All About Me',
        },
    [Authority.NCL] :
        {
            [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new Early Years Assessment Screen for the Child',
            [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the Early Years Assessment assessment for this child',
            [VariantString.SEND_CHECKER_TAB_TITLE] : 'Assessment Screen',
            [VariantString.ACTIONS_TAB_TITLE] : 'Support',
            [VariantString.DEFAULT_CHILD_TAB] : 'send',
            [VariantString.APPLICATION_NAME] : 'Newcastle Passport',
            [VariantString.INCLUSION_FUNDING_TITLE] : 'Early Years Inclusion Funding?',
            [VariantString.EHAP_LABEL] : 'EHAP',
            [VariantString.LAC_LABEL] : 'Care Status',
            [VariantString.SEND_BUTTON_TEXT] : 'Create new Assessment Screen',
            [VariantString.SEND_NARRATIVE] : 'This child has not yet had their first assessment screen, so you can start one now by clicking the button below.',
            [VariantString.SEND_PROVENANCE] : 'Assessment Screening',
            [VariantString.SEND_DASHBOARD_TITLE] : 'Progress',
            [VariantString.ESTABLISHMENT_LABEL] : 'Ofsted Number',
            [VariantString.ALL_ABOUT_ME_TITLE] : 'Transition Information',
        },
    [Authority.NTC] :
        {
            [VariantString.MODAL_SEND_ASSESSMENT] : 'You are about to start a new Early Years Assessment Screen for the Child',
            [VariantString.MODAL_SUBMIT_SEND_ASSESSMENT] : 'You are about to submit the Early Years Assessment assessment for this child',
            [VariantString.SEND_CHECKER_TAB_TITLE] : 'Assessment Screen',
            [VariantString.ACTIONS_TAB_TITLE] : 'Support',
            [VariantString.DEFAULT_CHILD_TAB] : 'send',
            [VariantString.APPLICATION_NAME] : 'North Tyneside Passport',
            [VariantString.INCLUSION_FUNDING_TITLE] : 'Early Years Inclusion Funding?',
            [VariantString.EHAP_LABEL] : 'EHAP',
            [VariantString.LAC_LABEL] : 'Care Status',
            [VariantString.SEND_BUTTON_TEXT] : 'Create new Assessment Screen',
            [VariantString.SEND_NARRATIVE] : 'This child has not yet had their first assessment screen, so you can start one now by clicking the button below.',
            [VariantString.SEND_PROVENANCE] : 'Assessment Screening',
            [VariantString.SEND_DASHBOARD_TITLE] : 'Progress',
            [VariantString.ESTABLISHMENT_LABEL] : 'Ofsted Number',
            [VariantString.ALL_ABOUT_ME_TITLE] : 'Transition Information',
        },

}

export const getVariant = ( authority, identifier ) =>
{
    if ( variants[authority] !== undefined )
    {
        if ( variants[authority][identifier] !== undefined )
        {
            return variants[authority][identifier] ;
        }
    }
}